import { useState } from 'react';
import { Button } from '@shopify/polaris';
import { client } from '../api/client';

/**
 * Downloads a CSV/PDF export from the given endpoint. PLAN.md §7.5.
 */
export default function ExportButton({
  url,
  params,
  filename = 'profitvault-export.csv',
  label = 'Export CSV',
}: {
  url: string;
  params?: Record<string, unknown>;
  filename?: string;
  label?: string;
}) {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const res = await client.get(url, { params, responseType: 'blob' });
      const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button onClick={handleExport} loading={loading}>
      {label}
    </Button>
  );
}
